<template>
    <header>
        <div class="big-heart">
            <ul class="left-tabs">
                <a href="/"><li>首页</li></a>
                <router-link to="/backtest"><li :class="$route.path.indexOf('/backtest') >= 0 ? 'active' : 'active_false'">回测一下</li></router-link>
                <router-link to="/strategybacktest"><li :class="$route.path.indexOf('/strategybacktest') >= 0 ? 'active' : 'active_false'">策略回测</li></router-link>
                <router-link to="/strategysquare"><li :class="$route.path.indexOf('/strategysquare') >= 0 ? 'active' : 'active_false'">策略广场</li></router-link>
                <router-link to="/eventevaluation"><li :class="$route.path.indexOf('/eventevaluation') >= 0 ? 'active' : 'active_false'">事件评测</li></router-link>
            </ul>
            <ul class="right-tabs">
                <router-link to="/mystrategy"><li :class="$route.path.indexOf('/mystrategy') >= 0 ? 'active' : 'active_false'"><span></span>我的策略</li></router-link>
            </ul>
        </div>
    </header>
</template>

<script>
    export default {
        name: 'header',
        computed: {
            // buriedPoint () {
            //     return this.$buriedPoint.navigationBar
            // }
        },
        components: {
        },
        data () {
            return {
            }
        },
        methods: {
            // home () {
            //     window.TA.log(this.buriedPoint.home)
            // },
            // backtestOnce () {
            //     window.TA.log(this.buriedPoint.backtestOnce)
            // },
            // strategyBacktest () {
            //     window.TA.log(this.buriedPoint.strategyBacktest)
            // },
            // strategySquare () {
            //     window.TA.log(this.buriedPoint.strategySquare)
            // },
            // eventEvaluation () {
            //     window.TA.log(this.buriedPoint.eventEvaluation)
            // },
            // myStrategy () {
            //     window.TA.log(this.buriedPoint.myStrategy)
            // }
        },
        mounted () {
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../scss/header.scss';
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue